import React from 'react';
export function Market() {
  return <section id="market" className="py-24 bg-cream" data-id="element-120">
      <div className="max-w-7xl mx-auto px-6" data-id="element-121">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-122">
          <div className="relative h-[600px] w-full" data-id="element-123">
            <img src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2000&auto=format&fit=crop" alt="Dubai Skyline" className="absolute inset-0 w-full h-full object-cover" data-id="element-124" />
            <div className="absolute inset-0 border border-charcoal/10 translate-x-4 translate-y-4 -z-10" data-id="element-125"></div>
          </div>

          <div data-id="element-126">
            <h2 className="text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-4" data-id="element-127">
              The Opportunity
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif mb-8 text-balance" data-id="element-128">
              Why the Dubai Beauty Market?
            </h3>

            <div className="space-y-6 text-lg font-light text-charcoal-light leading-relaxed" data-id="element-129">
              <p data-id="element-130">
                Dubai has strong demand for premium beauty, aesthetics and
                wellness services. The city attracts residents, tourists,
                entrepreneurs and high-income clients who are willing to invest
                in self-care, appearance and lifestyle.
              </p>
              <p data-id="element-131">
                However, the market is competitive. Success depends not only on
                a good location, but also on the right concept, pricing,
                marketing, team, service quality and financial discipline.
              </p>
              <p className="font-medium text-charcoal border-l-2 border-gold pl-6 py-2 italic" data-id="element-132">
                That is why buying or launching a beauty business in Dubai
                requires a clear strategy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}